import { render, staticRenderFns } from "./DepositOffexchangeTemp.vue?vue&type=template&id=ae906074&scoped=true&"
import script from "./DepositOffexchangeTemp.vue?vue&type=script&lang=js&"
export * from "./DepositOffexchangeTemp.vue?vue&type=script&lang=js&"
import style0 from "./DepositOffexchangeTemp.vue?vue&type=style&index=0&id=ae906074&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae906074",
  null
  
)

export default component.exports